import React, { Component } from 'react'
import { Page, SearchWithAction, CardBox, Table, FormSelect, DropdownButton } from '../../components'
import { fetchIndicatorGenerator, fetchIndicatorGeneratorFilters } from '../../api'
import { notify } from '../../utils'
import { connect } from 'react-redux'
import _ from 'lodash'
import { push } from '../../actions/nav-actions'

class IndicatorGenerator extends Component {
    state = {
        search: '',
        indicators: [],
        filters: {},
        selectedFilters: {},
        selected: undefined
    }
    componentDidMount() {
        this.fetch()
    }
    fetch = () => {
        const { organization, code } = this.getParams()
        const { selectedFilters } = this.state
        fetchIndicatorGenerator(this.props.user.token, organization, code, {
            ...selectedFilters,
            display: 'all',
            type: (selectedFilters.type || []).map(t => t.id)
        }).then((data) => {
            return fetchIndicatorGeneratorFilters(this.props.user.token, organization, code).then((filters) => ({ data, filters }))
        }).then(({ data, filters }) => {
            this.setState({ filters: filters, indicators: data.generator.indicators, selectedFilters: data.generator.results.filters })
        }).catch(err => {
            notify("Error to load", err.message, "error")
        })
    }
    getParams = () => {
        return this.props.match.params || {};
    }
    request = () => {
        this.fetch()
    }
    renderFilters = () => {
        const { selectedFilters } = this.state
        const { entries, types, indicators } = this.state.filters
        return (
            <div>
                <div className="row" style={{ marginBottom: 16, marginTop: 16 }}>
                    <FormSelect
                        className="col-4"
                        value={(selectedFilters.type || []).map(x => x.id)}
                        onChange={options => {
                            let { selectedFilters } = this.state;
                            selectedFilters.customFilters = 1
                            selectedFilters.type = options ? options.map(x => ({ id: x.value, name: x.label })) : [];
                            this.setState({ selectedFilters }, this.request);
                        }}
                        placeholder="Type of Program"
                        searchable multi
                        options={types.map(x => ({ value: x.value, label: x.name }))} />
                    <FormSelect
                        className="col-4"
                        value={(selectedFilters.entry_point || [])}
                        onChange={options => {
                            let { selectedFilters } = this.state;
                            selectedFilters.customFilters = 1
                            selectedFilters.entry_point = options ? options.map(o => o.value) : [];
                            this.setState({ selectedFilters }, this.request);
                        }}
                        placeholder="Entry Point"
                        searchable multi
                        options={entries.map(x => ({ value: x.value, label: x.name }))} />
                </div>
                <div className="row">
                    <FormSelect
                        className="col-4"
                        value={(selectedFilters.indicator || [])}
                        onChange={options => {
                            let { selectedFilters } = this.state;
                            selectedFilters.customFilters = 1
                            options = options ? options.map(x => _.castArray(x.value)) : []
                            selectedFilters.indicator = options.reduce((acc, values) => {
                                acc = [...acc, ...values]
                                return acc
                            }, []);
                            console.log("selectedFilters", selectedFilters)
                            this.setState({ selectedFilters }, this.request);
                        }}
                        placeholder="Primary Target Group"
                        searchable multi
                        options={indicators.map(x => ({ value: x.value, label: x.name }))} />
                </div>
            </div>
        )
    }
    renderEmpty = () => {
        return null
    }
    renderChild = () => {
        const params = this.getParams()
        return (
            [
                { Header: 'Indicator', accessor: 'indicator' },
                { Header: 'Assumptions', accessor: 'assumptions' },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <button
                            type="button" onClick={() => {
                                this.props.push(`/projects/indicator-generator/${params.organization}/${params.code}/${props.value._id}`)
                            }}
                            className="btn btn-block btn-light waves-effect waves-light">
                            Use Generator
                        </button>
                    )
                }
            ]
        )
    }
    render() {
        const { indicators } = this.state
        return (
            <Page title="Indicator Generator">
                <div className="row">
                    <div className="col-2">
                        <div className="btn-group" style={{ display: 'block' }}>
                            <button
                                type="button"
                                onClick={() => {
                                    this.setState({ showFilters: !this.state.showFilters })
                                }}
                                className="btn btn-block btn-light waves-effect waves-light">Filters</button>
                            {this.state.showFilters &&
                                <div className="dropdown-filters">
                                    {this.renderFilters()}
                                </div>
                            }
                        </div>
                    </div>
                    <SearchWithAction
                        className="col-10"
                        hideAction={true}
                        onChange={search => this.setState({ search })} />
                </div>
                <CardBox>
                    <Table
                        id="libraries"
                        renderEmpty={this.renderEmpty}
                        columns={this.renderChild()}
                        data={indicators} />
                </CardBox>
            </Page>
        )
    }
}
const mapStateToProps = state => ({
    user: state.authReducer.user,
    resources: state.resources
})

const mapDispatchToProps = dispatch => ({
    push(routeName) {
        dispatch(push(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorGenerator)


// WEBPACK FOOTER //
// ./src/routers/Projects/IndicatorGenerator.js